import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Products', path: '/products' },
  { label: 'Industries', path: '/industries' },
  { label: 'Quality', path: '/quality' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' }];


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-white/95 backdrop-blur-md shadow-md' :
      'bg-white/90 backdrop-blur-sm'}`
      }>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 flex-shrink-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_flex-line-1/artifacts/biaz9non_logo_GIP.png" 
              alt="Golden Plastic Industries Logo" 
              className="h-20 w-20 object-contain"
            />
            <div>
              <h1 className="text-2xl font-bold text-[#D8461D]">
                Golden Plastic
              </h1>
              <p className="text-xs text-slate-600 font-medium">Industries</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 font-medium transition-colors duration-200 hover:bg-orange-50 rounded-md ${
              location.pathname === link.path ?
              'text-[#D8461D] bg-orange-50' :
              'text-slate-700 hover:text-[#D8461D]'}`
              }>

                {link.label}
              </Link>
            )}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden md:block">
            <Link to="/contact">
              <Button className="inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 hover:bg-#b83817 transition-all duration-200 hover:shadow-lg text-sm font-medium gap-2 px-6 py-2 rounded-md shadow text-white !bg-[#D8461D]">
                Get Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-slate-700 hover:text-[#D8461D] transition-colors">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="md:hidden bg-white border-t border-slate-200 shadow-lg">
          <nav className="px-4 py-4 space-y-2">
            {navLinks.map((link) =>
          <Link
            key={link.path}
            to={link.path}
            onClick={() => setIsMobileMenuOpen(false)}
            className={`block w-full text-left px-4 py-3 hover:text-[#D8461D] hover:bg-orange-50 rounded-md font-medium transition-colors ${
            location.pathname === link.path ?
            'text-[#D8461D] bg-orange-50' :
            'text-slate-700'}`
            }>

                {link.label}
              </Link>
          )}
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="w-full bg-[#D8461D] hover:bg-#b83817 text-white mt-4">
                Get Quote
              </Button>
            </Link>
          </nav>
        </div>
      }
    </header>);

};